import ValueGeneratorInterface from "./ValueGeneratorInterface"
import RandomNumberGenerator from "../RandomNumberGenerator"
import NumberValue from "../../Model/Value/NumberValue"
import getDivisors from "../../util/factorize"
import ProductValue, {
  ProductSign,
  signs,
} from "../../Model/Value/ProductValue"

export default class ProductValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(value: number, level: number): boolean {
    return level >= 3 && getDivisors(value).length > 2
  }

  public generate(value: number): ProductValue {
    const sign: ProductSign =
      this.randomNumberGenerator.pick<ProductSign>(signs)
    const divisors: number[] = getDivisors(value).filter(
      (divisor: number): boolean => divisor !== 1 && divisor !== value,
    )

    if (divisors.length < 1) {
      throw new Error("Invalid Value number")
    }

    const dividend: number = this.randomNumberGenerator.pick(divisors)

    return new ProductValue(
      new NumberValue(dividend),
      sign,
      new NumberValue(value / dividend),
    )
  }
}
